import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import React from "react";
import { PulseLoader } from "react-spinners";
import Button from "../button/Button";
import MyButton from "../MyButton";
import "./index.scss";
import { Fonts, FontColors } from "theme/fontConfig";

export default function AlertDialog({
  content,
  onAccept,
  onDecline,
  open,
  handleClose,
  okButtonContent,
  noButtonContent,
  disable,
  isLoading,
}) {
  //Read Me!
  // on the buttonContent prop I send what we should desplay on the button
  //if you don't it desplay yes /no like before
  //fixed for the fillter.
  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
        <DialogContent style={{ overflow: "hidden" }}>
          <DialogContentText
            style={{
              display: "flex",
              justifyContent: "center",
              fontSize: Fonts.GeneralHeaderFont.fontSize,
              fontWeight: Fonts.GeneralHeaderFont.fontWeight,
              maxWidth: "500px",
              width: "100%",
              marginTop: "10px",
              textAlign: "center",
              color: FontColors.Blue012B57,
            }}
          >
            {content}
          </DialogContentText>
        </DialogContent>
        {!disable && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "25px",
            }}
          >
            <Button
              onClick={onAccept}
              variant="primary"
              size="md"
              style={{
                minWidth: 90,
                margin: "5px",
              }}
            >
              {isLoading ? (
                <PulseLoader color={"#fff"} size={"7px"} />
              ) : (
                okButtonContent || "Yes"
              )}
            </Button>
            {!okButtonContent && (
              <Button
                onClick={onDecline}
                content={noButtonContent || "No"}
                variant="primary-outline"
                size="md"
                style={{
                  minWidth: 90,
                  margin: "5px",
                }}
              >
                {noButtonContent || "No"}
              </Button>
            )}
          </div>
        )}
      </Dialog>
    </div>
  );
}
